import React, {useEffect, useState} from 'react';
import {FormBudgetProject} from '@/services/sales/bp/formBudgetProject';
import {WdiGridApp} from '@/components/WdiBus/PanelForWarning';
import {wdiCore} from "@/components/WdiControls";
import {ColumnsType} from "antd/lib/table";

const HQSubmitBudgetInfos: Record<string, any> = {
  bohqId: (_: any, record: any) => {
    return record['bohqName'];
  },
  boId: (_: any, record: any) => {
    return record['boName'];
  },
  ecId: (_: any, record: any) => {
    return record['ecName'];
  },
  productId: (_t: any, record: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.productCode, record.productName);
    }
    return ""
  },
  amountTotal: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountTotal'], 2);
  },
  amountApproving: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproving'], 2);
  },
  amountApproved: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproved'], 2);
  },
  amountClosed: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountClosed'], 2);
  },
  amountContract: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountContract'], 2);
  },
  amountPd: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountPd'], 2);
  },
  amountRemain: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountRemain'], 2);
  },
  amount: (_: any, record: any) => {
    if (record['amount'] > record['amountRemain']) {
      return <span style={{color: '#ff0000'}}>{wdiCore.Number.AmountToString(record['amount'], 2)}</span>;
    }
    return wdiCore.Number.AmountToString(record['amount'], 2);
  },
  amountNonTpm: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountNonTpm'], 2);
  },
};

const HQBudgetAmount: Record<string, any> = {
  bohqId: (_: any, record: any) => {
    return record['bohqName'];
  },
  boId: (_: any, record: any) => {
    return record['boName'];
  },
  ecId: (_: any, record: any) => {
    return record['ecName'];
  },
  productId: (_t: any, record: any) => {
    if (record) {
      return wdiCore.String.CodeOrName(record.productCode, record.productName);
    }
    return ""
  },
  amountTotal: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountTotal'], 2);
  },
  amountApproving: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproving'], 2);
  },
  amountApproved: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproved'], 2);
  },
  amountClosed: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountClosed'], 2);
  },
  amountContract: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountContract'], 2);
  },
  amountPd: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountPd'], 2);
  },
  amountRemain: (_: any, record: any) => {
    if (record['amountRemain'] < 0) {
      return <span style={{color: '#ff0000'}}>{wdiCore.Number.AmountToString(record['amountRemain'], 2)}</span>;
    }
    return wdiCore.Number.AmountToString(record['amountRemain'], 2);
  },
  amount: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amount'], 2);
  },
  amountNonTpm: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountNonTpm'], 2);
  },
};

const columnsRenders: Record<string, Record<string, any>> = {
  HQSubmitBudgetInfos: HQSubmitBudgetInfos,
  HQBudgetAmount: HQBudgetAmount,

};
const BudgetInformation: React.FC<{ formId?: number }> = (props) => {
  const [budgetInfos, setBudgetInfos] = useState<API.WdiGrid[]>([]);

  useEffect(() => {
    (async () => {
      if (props.formId) {
        const response = await FormBudgetProject.Buttons.budgetInfos(props.formId);
        /*  const newData = [];
          const currentGrid = Object.assign({}, response?.data?.current, {
            key: "CurrentHQBudgetAmount",
            displayName: '当前预算信息'
          });
          newData.push(currentGrid);
          const submitGrid = Object.assign({}, response?.data?.current, {
            key: "SubmitHQBudgetAmount",
            displayName: '提交时预算信息',
            items: response.data.submit
          });
          newData.push(submitGrid);*/
        setBudgetInfos(response?.data.items);
      }
    })();
  }, [props.formId]);

  const renderWdiGridApp = (props: API.WdiGrid) => {
    const columns: ColumnsType<any> = [];
    const columnsRender = columnsRenders[props.key];

    props.wdiColumns.map((wdiColumn) => {
      if (!wdiColumn.isHidden) {
        const column: any = {
          title: wdiColumn.displayName,
          dataIndex: wdiColumn.name,
          width: wdiColumn.width,
          ellipsis: true,
          //  render: FormBudgetInfo[wdiColumn.name]
        };
        if (columnsRender && columnsRender[wdiColumn.name]) {
          column.render = columnsRender[wdiColumn.name];
        }
        columns.push(column);
      }
    });

    return (
      <WdiGridApp
        key={props.key}
        wdiGrid={props}
        columns={columns}
        dataSource={props.items}
      />
    );
  };

  return (
    <>
      {budgetInfos.map((item) => {
        return (
          renderWdiGridApp(item)
        );
      })}
    </>
  );
};

export default BudgetInformation;
